import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getUrl, postUrl, putUrl } from '@/utils/fetch_helpers'
import { useCoreUserStore } from '@/stores/CoreStore'

const URL = `${process.env.VUE_APP_PIPES}/finances/categories`

export const createCategoryStore = (id, opts = {}) => defineStore(`category-${id}`, () => {
  // state
  const name = ref(opts.name || '')
  const color = ref(opts.color || '')
  const priority = ref(opts.priority || 0)
  const group = ref(opts.group || '')
  const history = ref(opts.history || {})
  const recent = ref(opts.recent || [{}])
  const fetched = ref(opts.fetched || false)

  // actions
  const fetch = (force = false) => {
    if (fetched.value && !force) {
      return Promise.resolve()
    }

    return getUrl(`${URL}/${id}`).then(res => {
      fetched.value = true
      parse(res)
    })
  }

  const create = (data) => {
    return postUrl(
      URL,
      JSON.stringify({
        ...data,
        user_id: useCoreUserStore().userId
      }),
      {},
      {'Content-Type': 'application/json'}
    ).then(res => {
      return res
    })
  }

  const update = (data) => {
    return putUrl(
      `${URL}/${id}`,
      JSON.stringify(data),
      {},
      {'Content-Type': 'application/json'}
    ).then(res => {
      parse(res)
    })
  }

  const reset = () => {
    fetched.value = false
  }

  const parse = (res) => {
    name.value = res.name
    color.value = res.color
    group.value = res.group
    history.value = res.history
    recent.value = res.recent
    priority.value = res.priority
  }
  
  return {
    id,
    name,
    color,
    group,
    history,
    recent,
    priority,
    create,
    fetch,
    update,
    reset,
  }
})
